import React, {useState, useEffect} from 'react';
import './RelatedProducts.css';
import Item from '../Item/Item';
import axios from 'axios'; 

const RelatedProducts = () => {
  const product = JSON.parse(localStorage.getItem("currentProd"));
  const [dataProduct, setDataProduct] = useState([]);

  const apiURL = process.env.REACT_APP_API_URL;

  // var options = {  
  //   method: 'GET',
  //   headers: {
  //       'Accept': 'application/json',
  //       'Content-Type': 'application/json',
  //       'Origin': '',
  //       Accept: 'application/json', 
  //       'ngrok-skip-browser-warning': "10423"
  //   }
  // }

  useEffect(() => {
    const apiURL = process.env.REACT_APP_API_URL;
    // window.scrollTo(0, 0); 
    axios.get(apiURL + `api/products/get/type?category=${encodeURIComponent(product.kind)}`, {
        headers: {
            Accept: 'application/json',
            "ngrok-skip-browser-warning": "10423"
        }
    })
    .then((res) => {
      setDataProduct(res.data);
    })
    .catch((err) => console.log(err));
    // const fetchProducts = async () => {
    //   try {
    //       const response = await fetch(apiURL + `api/products/get/type?category=${encodeURIComponent(product.category)}`, options);
    //       const data = await response.json();
    //       setDataProduct(data);
    //   } catch (error) {
    //       console.error('Failed to fetch common values', error);
    //   }
    // };

    // fetchProducts();
  }, []);

  return (
    <div className='relatedproducts'>
        <h3>Related Products</h3>
        <hr></hr>
        <div className="relatedproducts-item">
            {dataProduct.map((item, i) => {
              if(item.id !== product.id)
                return <Item key={i} id={item.id} name={item.name} img={item.img} price={item.price}/>
            })}
        </div>
        <hr className="solid-line" />
    </div>
  )
}

export default RelatedProducts